import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import { isAuthenticated } from "@/code/axios";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/servers",
    name: "Servers",
    component: () => import(/* webpackChunkName: "servers" */ "../views/Servers.vue"),
  },
  {
    path: "/order",
    name: "Order",
    component: () => import(/* webpackChunkName: "order" */ "../views/Order.vue"),
  },
  {
    path: "/ordersuccess",
    name: "OrderSuccess",
    component: () => import(/* webpackChunkName: "ordersuccess" */ "../views/OrderSucces.vue"),
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import(/* webpackChunkName: "contacts" */ "../views/Contacts.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import(/* webpackChunkName: "logout" */ "../views/Logout.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import(/* webpackChunkName: "signup" */ "../views/Signup.vue"),
  },
  {
    path: "/recover",
    name: "Recover",
    component: () => import(/* webpackChunkName: "recover" */ "../views/Recover.vue"),
  },
  {
    path: "/checkmail",
    name: "CheckMailDialog",
    component: () => import(/* webpackChunkName: "checkmail" */ "../views/CheckMailDialog.vue"),
  },
  {
    path: "/setnewpassword",
    name: "SetNewPassword",
    component: () => import(/* webpackChunkName: "setnewpassword" */ "../views/SetNewPassword.vue"),
  },
  {
    path: "/personal",
    name: "Personal",
    component: () => import(/* webpackChunkName: "personal" */ "../views/Personal.vue"),
  },
  {
    path: "/document",
    name: "DocViewer",
    component: () => import(/* webpackChunkName: "document" */ "../views/DocViewer.vue"),
  },
  {
    path: "/*",
    name: "Http404",
    component: () => import(/* webpackChunkName: "http404" */ "../views/Http404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === "Login" && isAuthenticated()) {
    next({ name: "Personal" });
  } else if (to.name === "Signup" && isAuthenticated()) {
    next({ name: "Personal" });
  } else if (to.name === "Logout" && !isAuthenticated()) {
    next({ name: "Personal" });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  if (to.name != from.name && from.name != undefined) {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }
});

const originalPush = router.push;
router.push = function push(location) {
  if (location.query === undefined && location.path === router.currentRoute.path) {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  } else {
    return originalPush.call(this, location);
  }
};

export default router;
